// ForgotPasswordModal.js
// @author: anghello

import React, { useCallback, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Col,
  Row,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import WAM from '../../../services/WAM';
import Button1 from '../../../components/buttons/Button1';

export default function ForgotPasswordModal({ isOpen, toggle }) {
  const { register, formState: { errors }, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async ({ username }) => {
      setLoading(true);

      try {
        const response = await WAM.forgot(username);

        setLoading(false);

        if (response.result === 'success') {
          toast.success(Strings('a_new_password_has_been_send_to_your_email'));
          reset();
          toggle();
        } else {
          const message = response?.error || Strings('error_on_forgot_password_request');
          toast.error(message);
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
        toast.error(Strings('general_error'));
      }
    },
    [reset, toggle]
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{Strings('application_title')}</ModalHeader>
      <ModalBody>
        <div className="mb-2">
          <h6 className="opacity-8">{Strings('forgot_your_password')}</h6>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Row>
            <Col md={12}>
              <FormGroup>
                <input
                  type='text'
                  name='username'
                  placeholder={Strings('username_email')}
                  {...register('username', { required: true })}
                  className='form-control pb-input-1'
                />
                {errors && errors.username && errors.username.type === 'required' && (
                  <p role='alert' className='text-danger txt-small-1'>{Strings('username_is_required')}</p>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <div className="mt-2 mb-2 d-flex justify-content-between">
              <a
                className="pb-link-1"
                href="/#"
                onClick={(evt) => {
                  evt.preventDefault();
                  toggle();
                }}
              >
                {Strings('return_to_login')}
              </a>
            </div>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button1
          className="pb-btn-1"
          type="submit"
          size="lg"
          onClick={handleSubmit(onSubmit)}
          loading={loading}
        >
          {Strings('recover_password')}
        </Button1>
      </ModalFooter>
      <div className="text-center opacity-8 pb-3">
        Copyright © Photozig Inc.
      </div>
    </Modal>
  );
}